import { DirectCollectService } from 'apps/phoenix/src/app/features/direct-collection/services/direct-collect.service';

import { Component, Input, OnInit, inject } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'phoenix-translation-switch',
  template: `
    @if (translationsEnabled) {
      <mat-slide-toggle
        labelPosition="before"
        class="small-toggle"
        [checked]="checked"
        [disabled]="disabled"
        (change)="toggleTranslation($event)"
        matTooltip="Translate"
      >
        @if (translateLabel) {
          <span class="mr-2">{{ label }}</span>
        } @else {
          <mat-icon class="ml-2 mt-2">translate</mat-icon>
        }
      </mat-slide-toggle>
    }
  `,
  styles: [
    `
      .small-toggle {
        transform: scale(0.7);
        transform-origin: right center;
      }

      :host ::ng-deep .mdc-label {
        font-size: 1.25rem;
      }
    `,
  ],
  standalone: false,
})
export class TranslationSwitchComponent implements OnInit {
  @Input() translationsEnabled = false;
  @Input() translateLabel: string = '';

  checked = false;
  disabled = false;

  dcService = inject(DirectCollectService);

  ngOnInit() {
    const storedValue = localStorage.getItem('showDCVTranslations');
    this.checked = storedValue === 'true';
    this.dcService.showTranslations = this.checked;
  }

  get label(): string {
    if (!this.checked) {
      return this.translateLabel?.trim() || 'Original';
    }
    return 'Translation';
  }

  toggleTranslation(event: MatSlideToggleChange) {
    this.checked = event.checked;
    this.dcService.showTranslations = this.checked;
    localStorage.setItem('showDCVTranslations', this.checked.toString());
  }
}
